import { render } from "./PregnancyInfoRecommendations.vue?vue&type=template&id=67593b54&scoped=true"
import script from "./PregnancyInfoRecommendations.vue?vue&type=script&lang=js"
export * from "./PregnancyInfoRecommendations.vue?vue&type=script&lang=js"

import "./PregnancyInfoRecommendations.vue?vue&type=style&index=0&id=67593b54&scoped=true&lang=scss"
import "./PregnancyInfoRecommendations.vue?vue&type=style&index=1&id=67593b54&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67593b54"]])

export default __exports__